<div style="display: flex; justify-content: center; align-items: center">
  <h1>404 - Page Not Found</h1>
</div>
<div style="display: flex; justify-content: center; align-items: center">
  <h2>
    Please <a routerLink="/reports">click-here</a> to return to home page.
  </h2>
</div>
